import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LanguageService } from './language.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./language.service";
var OrganismService = /** @class */ (function () {
    function OrganismService(http, languageSrv) {
        this.http = http;
        this.languageSrv = languageSrv;
        this.baseUrl = environment.apiUrl + 'organisms';
    }
    OrganismService.prototype.getList = function () {
        return this.http.get(this.baseUrl + "/" + this.languageSrv.getCurrentLanguageCode());
    };
    OrganismService.ngInjectableDef = i0.defineInjectable({ factory: function OrganismService_Factory() { return new OrganismService(i0.inject(i1.HttpClient), i0.inject(i2.LanguageService)); }, token: OrganismService, providedIn: "root" });
    return OrganismService;
}());
export { OrganismService };
